// SF 監査スナップショット API クライアント。GET /sf/audit/snapshots(一覧) / /sf/audit/snapshots/{id}(詳細)。
// ApiClient に認証・エラー正規化を委譲。backend SnapshotSummary/SnapshotRecord に対応する DTO。
import type { ApiClient } from "../api/client";

export interface SnapshotApiDeps {
  readonly apiClient: ApiClient;
}

export interface SnapshotSettingDto {
  readonly key: string;
  readonly value: string;
}

export interface SnapshotSummaryDto {
  readonly snapshotId: string;
  readonly takenAt: string;
  readonly settingCount: number;
  readonly orgId: string;
  readonly trigger: "manual" | "scheduled";
  readonly runId: string;
  readonly actorSub: string;
}

export interface SnapshotDetailDto extends Omit<SnapshotSummaryDto, "settingCount"> {
  readonly settings: SnapshotSettingDto[];
}

// GET /sf/audit/snapshots → SnapshotSummaryDto[]（新しい順は backend が保証）
export async function listSnapshots(deps: SnapshotApiDeps): Promise<SnapshotSummaryDto[]> {
  return deps.apiClient.get<SnapshotSummaryDto[]>("/sf/audit/snapshots");
}

// GET /sf/audit/snapshots/{snapshotId} → SnapshotDetailDto（settings 込み）
export async function getSnapshot(deps: SnapshotApiDeps, snapshotId: string): Promise<SnapshotDetailDto> {
  return deps.apiClient.get<SnapshotDetailDto>(`/sf/audit/snapshots/${encodeURIComponent(snapshotId)}`);
}
